<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/PQMYhk/tc-custom/9781937384975.jpg?1725723386521" alt="This image is the cover for the book Spinsters in Jeopardy, Roderick Alleyn"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Spinsters in Jeopardy, Roderick Alleyn
      </h1>
      <p class="bookDescription body article font2">
        <b>A British police detective looks into sinister doings in the South of France in a crime thriller with “more than a little excitement” (<i>Kirkus Reviews</i>).</b><br/><br/> Inspector Roderick Alleyn has decamped for the South of France on a family vacation—though for him, the vacation will involve some official poking around. Unfortunately, the object of his poking—the cultish denizens of a sinister and luxurious chateau—are not fond of being poked, and they have a particularly unpleasant way of getting their point across . . .<br/><br/> “Charming, cultivated, witty—and none the less terrifying . . .a pure thriller . . .you’re not apt to find a better evening’s entertainment.” —<i>The New York Times</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Ngaio Marsh
      </h2>
      
      <p class="authorDescription body article">Ngaio Marsh (1895-1982) was one of the celebrated queens of the Golden Age of detective fiction; born in New Zealand, she wrote 32 novels in the &quot;Inspector Alleyn&quot; series.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Felony & Mayhem Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?12c79fca